import * as React from "react";
import { NavContainer, TitleBox } from "./style";
const PCLitbNav = (props) => {
    const { positionId, navModules, stickToTop } = props;
    const onScroll = (link) => () => {
        const linkID = link.substr(1);
        let dom = document.getElementById(linkID);
        dom === null || dom === void 0 ? void 0 : dom.scrollIntoView({ block: "start" });
        setTimeout(() => {
            window.scrollBy(0, -(stickToTop ? stickToTop : 0));
        }, 0);
    };
    return (React.createElement("section", { id: positionId },
        React.createElement(NavContainer, null, navModules.map((ele, index) => {
            return (React.createElement("a", { key: index, onClick: onScroll(ele.link) },
                React.createElement(TitleBox, { color: ele.bgColor === ("#ffffff" || "#fff") ? "#666" : "#fff", bgColor: ele.bgColor || "#fff" }, ele.text),
                React.createElement("img", { src: ele.img, alt: "" })));
        }))));
};
export default PCLitbNav;
